import React from 'react';

const RectangleCustomSvg = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path d="M6 21h13V3H6v18zM5 2h15v20H5V2z" fillRule="nonzero" />
    </svg>
);

RectangleCustomSvg.displayName = 'RectangleCustomSvg';
export default RectangleCustomSvg;
